<div class="flex flex-col min-h-screen">
    <div class="grow">
        <ng-content select="header" />
        <ng-content select="mainContent" />
    </div>
    <ng-content select="footer" />
</div>
